import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const UnorderedList = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='UnorderedList' {...props}>
    <rect x='5.94' y='6.42' width='18.06' height='1.75' /><rect x='5.94' y='11.71' width='18.06' height='1.75' /><rect x='5.94' y='16.99' width='18.06' height='1.75' /><circle cx='1.85' cy='7.29' r='1.52' /><circle cx='1.85' cy='12.58' r='1.52' /><circle cx='1.85' cy='17.87' r='1.52' />
  </StyledIcon>
);
